import { CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	startRange: 'startRange',
	endRange: 'endRange',
	totalPercentage: 'totalPercentage',
	totalFlatValue: 'totalFlatValue',
	cashbackPercentage: 'cashbackPercentage',
	cashbackFlatValue: 'cashbackFlatValue',
	bonusPercentage: 'bonusPercentage',
	bonusFlatValue: 'bonusFlatValue'
};

export const conversionsConfig = [
	CategoricalColumn({
		title: 'Winnning Wallet amount start range(₹)(Incl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.startRange]?.toLocaleString('en-IN')
	}),
	CategoricalColumn({
		title: 'Winnning Wallet amount end range(₹)(Excl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.endRange]?.toLocaleString('en-IN')
	}),
	CategoricalColumn({
		title: 'Total Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.totalPercentage] || '0'
	}),
	CategoricalColumn({
		title: 'Cashback Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackPercentage] || '0'
	}),
	CategoricalColumn({
		title: 'Bonus Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.bonusPercentage] || '0'
	}),
	CategoricalColumn({
		title: 'Total Flat Value(₹)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.totalFlatValue]?.toLocaleString('en-IN') || '0'
	}),
	CategoricalColumn({
		title: 'Cashback Flat Value(₹)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackFlatValue]?.toLocaleString('en-IN') || '0'
	}),
	CategoricalColumn({
		title: 'Bonus Flat Value(₹)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.bonusFlatValue]?.toLocaleString('en-IN') || '0'
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 0,
		pageSize: 100
	},
	sortDetails: {
		sortField: 'code',
		sortOrder: 'ASC'
	}
};
